import type {ReactElement} from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';

const PANEL_ID = 'poster-editor-ai-edit-panel';
const MOBILE_HEIGHT = '800px';

export default function PosterEditorAiEditModal(): ReactElement {
  return (
    <Modal
      modalId={MODALS_IDS.POSTER_EDITOR_AI_EDIT_MODAL}
      panelId={PANEL_ID}
      isBottomSheetOnMobile
      isBottomSheetNonBlocking
      modalHeight={MOBILE_HEIGHT}
      mobileHeight={MOBILE_HEIGHT}
      modalWidth="100%"
    >
      <LazyPanel
        panelDirectoryName={PANEL_ID}
        panelProps={{
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openAiEditModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_AI_EDIT_MODAL,
      panelProps: {
        panelId: PANEL_ID,
      },
    })
  );
};
